import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icons'
import Menu from '../Menu'
import { View, StyleSheet } from 'react-native'
import { useTheme } from '../../theming/ThemeProvider'

const getApplyFilters = obj => {
  return obj ? Object.keys(obj).length : false
}
const FilterMenu = ({ openFilters, handleClearFilters, applyFilters }) => {
  const { theme } = useTheme()
  const styles = useStyles(theme)
  const menuItems = [
    {
      text: 'More filters',
      fn: openFilters
    }, {
      text: 'Clear filters',
      fn: handleClearFilters
    }
  ]
  return (
    <View style={styles.row}>
      <Menu
        style={[
          styles.filters
        ]}
        items={menuItems}
      >
        <>
          <Icon
            name='Filter'
            width={20}
            height={20}
            fill={getApplyFilters(applyFilters) ? theme.LOCHMARA : theme.AZTEC}
          />
          {getApplyFilters(applyFilters) ? (<View style={styles.applyFilters} />) : null}

        </>
      </Menu>
    </View>
  )
}

const useStyles = (theme) => StyleSheet.create({
  row: {
    width: '100%',
    alignItems: 'flex-end'
  },
  filters: {
    marginLeft: 10,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 100,
    position: 'relative',
    backgroundColor: theme.CATSKILL_WHITE
  },
  applyFilters: {
    width: 8,
    height: 8,
    position: 'absolute',
    right: -2,
    top: 5,
    backgroundColor: theme.LOCHMARA,
    borderRadius: 100
  }
})

FilterMenu.propTypes = {
  openFilters: PropTypes.func.isRequired,
  handleClearFilters: PropTypes.func.isRequired,
  applyFilters: PropTypes.object.isRequired
}

export default FilterMenu
